// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pc_a bhr_sn bhr_sv bhr_sw bhr_kx bhr_ky bhr_ke undefined bhr_vt"};